// Copyright (c) 2017 Deere & Company

import ReportResultsContainer from './report-results';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    columnApi: state.columnApi,
    gridApi: state.gridApi,
    isInitialLoad: state.reportVariant.isInitialLoad,
    isReportColumnsVisible: state.reportVariant.isReportColumnsVisible,
    layouts: state.reportVariant.layouts,
    report: state.reports.pipHistory.report,
    selectedLayout: state.reportVariant.selectedLayout,
    showNoResultsFound: state.reports.pipHistory.showNoResultsFound
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => {

    const {
        createAgGridApi
    } = dispatchProps;

    return {
        ...stateProps,
        actions: {
            createAgGridApi
        }
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ReportResultsContainer);



// WEBPACK FOOTER //
// ./src/reports/pip-history/components/report-results/index.js